import { render } from "./CheckboxTree.vue?vue&type=template&id=4da07e7e&ts=true"
import script from "./CheckboxTree.vue?vue&type=script&lang=ts"
export * from "./CheckboxTree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__